import { Component, Input, OnInit } from '@angular/core';
import { ModalController, ToastController } from '@ionic/angular';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

import { endpoints } from 'src/app/constant/endpoints';
import { ApiService } from 'src/app/provider/api.service';
import { first } from 'rxjs/operators';

@Component({
  selector: 'app-comment-modal',
  templateUrl: './comment-modal.page.html',
  styleUrls: ['./comment-modal.page.scss'],
  standalone: false,
})
export class CommentModalPage implements OnInit {
  @Input() customer_id?: any;
  @Input() post_id?: any;
  loading: boolean = false;
  public commentForm: FormGroup<any>;
  constructor(private formBuilder: FormBuilder, public modalCtrl: ModalController, private toastCtrl: ToastController, private translate: TranslateService, private apiService: ApiService) {
    this.commentForm = this.formBuilder.group({
      post_id: new FormControl(this.post_id, Validators.compose([Validators.required])),
      customer_id: new FormControl(this.customer_id, Validators.compose([Validators.required])),
      content: new FormControl('', Validators.compose([Validators.required, Validators.minLength(1)])),
    });
  }
  ngOnInit() {}
  onSubmit = () => {
    if (!this.commentForm) return;
    
    this.loading = true;

    this.apiService
      .post(endpoints.comments, this.commentForm.value)
      .pipe(first())
      .subscribe(
        async (response: any) => {
          this.loading = false;

          if (response.success) {
            this.modalCtrl?.dismiss({ status: true, content: this.commentForm?.value.content }, 'cancel');
          } else {
            this.modalCtrl?.dismiss(false, 'cancel');
          }
          this.toastMessage(response.message);
        },
        (_err) => {
          this.modalCtrl?.dismiss(false, 'cancel');
        },
      );
  };
  closeModal = () => {
    this.modalCtrl?.dismiss(false, 'cancel');
  };
  toastMessage = async (msg: any) => {
    await this.toastCtrl
      .create({
        message: this.translate?.instant(msg),
        duration: 4000,
        position: 'top',
        color: 'primary',
      })
      .then((toastElem: any) => toastElem.present());
  };
}
